import { BaseContext } from '../../../../utils/basecontext';
import { HttpClient } from '../../../../utils/httpclient/httpclient';
import {  POST } from '../../api';
import { SixdeeCRBTAPI } from '../../sixdeecrbtapi';
import { FlashSubscriptionDetailsRequest } from './getsubscriptiondetailsrequest';

export class FlashSubscriptionDetailsAPI extends SixdeeCRBTAPI<FlashSubscriptionDetailsRequest>
{
    constructor(httpClient:HttpClient, appContext: BaseContext){
        super(httpClient, appContext);
    }

    getHttpMethod(){
        return POST;
    }
    getAPIURL(): string
    { 
        return "flash/subscriber-management/subscribers/get-subscription";
    }

    protected getRequestData() {
        return {
            "msisdn": this.getRequest().getMsisdn(),
            "type":"FLASH"
        };
    }

    getBASEURL(): string
    {
        return this.getContext().getProperty().getFlashURL() + 
            this.getAPIURL();
    }
}






// WEBPACK FOOTER //
// ./src/com/sixdee/crbtportal/core/api/flashmessage/getflashsubscriptiondetails/getsubscriptiondetailsapi.tsx